import { Cart } from '@diamond/shared/types';

export interface EcommerceItem {
  id: string;
  item_id?: string;
  item_name?: string;
  item_brand?: string;
  affiliation?: string;
  coupon?: string;
  discount?: number;
  index: number;
  item_category?: string;
  item_category2?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  location_id?: string;
  price?: number;
  quantity?: number;
}

export const buildEcommerceItems = (
  cart: Cart[],
  warehouseId: string
): EcommerceItem[] => {
  return cart.map((item, index) => ({
    id: item.id,
    item_id: item.product.item_code?.toString(),
    item_name: item.product.title,
    item_brand: item.product.brand_name,
    affiliation: item.product.brand_desc,
    coupon: item.product.discount_promos?.[0]?.promo_code || '',
    discount: item.product.discount_promos?.[0]?.deduction_amount || 0,
    index,
    item_category: item.product.category_name,
    item_category2: item.product.sub_category_name,
    item_list_id: 'cart',
    item_list_name: 'Cart',
    item_variant: item.product.type || '',
    location_id: warehouseId,
    price: item.product.prices?.[0]?.price || 0,
    quantity: item.quantity / 1000 || 1,
  }));
};
